import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowTopRight"><Path d="M10.5 5.5H3.5V20.5H18.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 3.5H20.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20 4L11.5 12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowTopRight;
